import * as React from 'react';
import { useContext } from 'react';

import { ProfileContext } from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileContextProvider';
import ProfileSectionWithTitle from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileSectionWithTitle';
import CoursesSection from 'bundles/account-profile/components/recruiting-profile-viewer/components/courses/CoursesSection';
import CredentialsSection from 'bundles/account-profile/components/recruiting-profile-viewer/components/credentials/CredentialsSection';

import _t from 'i18n!nls/account-profile';

const EducationSection = () => {
  const { isProfileLoading, profileState = {}, editable, courseraHistoryFailedToLoad } = useContext(ProfileContext);
  const { educationHistory, courseraHistory } = profileState;
  const hasCourseraHistory = Boolean(
    courseraHistory?.completedProfessionalCertificates?.length ||
      courseraHistory?.completedSpecializations?.length ||
      courseraHistory?.completedCourses?.length ||
      courseraHistory?.learningStats ||
      courseraHistoryFailedToLoad // If failed to load, we can't guarantee they have no items so we show an error instead
  );

  if (!editable && !isProfileLoading && !educationHistory?.length && !hasCourseraHistory) return null;

  return (
    <ProfileSectionWithTitle title={_t('Education')}>
      <CredentialsSection />
      <CoursesSection />
    </ProfileSectionWithTitle>
  );
};

export default EducationSection;
